import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FormMode } from '../../common/form-mode';
import { WorkflowDataInterface } from '../workflow-data.interface';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subject } from 'rxjs';
import { CallApiActionData } from 'src/app/components/designer/models/call-api-action-data';
import { RestApiConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-configuration';
import { ContextualMenuEvent } from '../contextual-menu-event';
import { NeedApiConfigurations } from '../need-api-configurations';

@Component({
    selector: 'app-workflow-action-call-api-data',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, FaIconComponent, MatTooltipModule, MatCheckboxModule],
    templateUrl: './workflow-action-call-api-data.component.html',
    styleUrl: './workflow-action-call-api-data.component.scss'
})
export class WorkflowActionCallApiDataComponent implements WorkflowDataInterface, OnInit, NeedApiConfigurations {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Données affichées par le composant dynamique.
     */
    public _data: CallApiActionData;

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    set data(value: string | CallApiActionData) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as CallApiActionData;
        }

        this.fillForm();
    }

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    get data(): CallApiActionData {
        this.fillData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Liste des configurations d'API.
     */
    public _apiConfigurations: RestApiConfiguration[];

    /**
     * Spécifie la liste des configurations d'API.
     */
    set apiConfigurations(value: RestApiConfiguration[]) {
        this._apiConfigurations = value;
        this.fillForm();
    }

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        this.dataForm = new UntypedFormGroup({
            configurationApiId: new UntypedFormControl({ value: '' }, [Validators.required]),
        });

        if (this.mode === FormMode.Reading) {
            this.dataForm.disable();
        } else {
            this.dataForm.enable();
        }

        this.fillForm();
    }

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }

    /**
     * Remplit le formulaire avec les données.
     */
    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                if (this._apiConfigurations) {
                    this.dataForm.get('configurationApiId').setValue(this._data.configurationApiId);
                }
            }
        }
    }

    /**
     * Met à jour les données à partir du formulaire.
     */
    private fillData() {
        let updatedData: CallApiActionData = new CallApiActionData();
        updatedData.configurationApiId = this.dataForm.get('configurationApiId').value;

        this._data = updatedData;
    }
}
